export default "__VITE_ASSET__CYx_hC98__"